import { errorNotifier } from './helpers';
import { statusCodes } from './constants';

export const networkErrorHandler = (statusCode, message) => {
  const { INTERNAL_SERVER_ERROR, CONFLICT, BAD_REQUEST, UNAUTHORIZED, POOR_INTERNET } =
    statusCodes;
  switch (statusCode) {
    case INTERNAL_SERVER_ERROR: {
      errorNotifier(
        `Error ${statusCode}:  ${message}` ||
          `Error ${statusCode}: An error ocurred, but don't worry the problem is from our end.`
      );
      break;
    }
    case BAD_REQUEST: {
      errorNotifier(
        `Error ${statusCode}:  ${message}` ||
          `Error ${statusCode}: Please double check your fields, something is not quite right.`
      );
      break;
    }
    case CONFLICT: {
      errorNotifier(`Error ${statusCode}:  ${message}` || `Error ${statusCode}: There seems to be conflicting information.`);
      break;
    }
    case UNAUTHORIZED: {
      errorNotifier(
        `Error ${statusCode}:  ${message}` ||
          `Error ${statusCode}: You are not authorized to view this resource, please ensure you are logged in or you have the necessary permissions.`
      );
      break;
    }
    case POOR_INTERNET: {
      errorNotifier(message);
      break;
    }
    default: {
      errorNotifier(`Error ${statusCode}:  ${message}` || `Error ${statusCode}: Something went wrong, please try again later.`);
      break;
    }
  }
};

export const clientErrorHandler = (message) =>
  errorNotifier(
    message ||
      'Something went wrong, we have notified our engineers to get this fixed.'
  );
  